import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Billeterie from "./pages/Billeterie";
import Affretement from "./pages/Affretement";
import Voyages from "./pages/Voyages";
import Evenements from "./pages/Evenements";
import APropos from "./pages/APropos";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/billeterie" element={<Billeterie />} />
          <Route path="/affretement" element={<Affretement />} />
          <Route path="/voyages" element={<Voyages />} />
          <Route path="/evenements" element={<Evenements />} />
          <Route path="/a-propos" element={<APropos />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
